import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { auth } from "@envirohub/utils";

/** Guard: redirect unauthenticated users to /login; forced reset to /change-password. */
export function PrivateRoute({ children }: { children: ReactNode }) {
  const location = useLocation();

  if (!auth.isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (auth.getSession()?.mustResetPassword === true && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }

  return children;
}
